import React from "react"
// eslint-disable-next-line no-restricted-imports
import { colors } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import { Toaster } from "react-hot-toast"
import { FontFamily } from "../../css/fonts"

export function CarrotToaster(): JSX.Element {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        success: {
          iconTheme: {
            primary: `${colors.base.darkGreen}`,
            secondary: "#fff"
          },
          style: {
            background: "#DDEBE2",
            padding: "24px 12px",
            fontFamily: `${FontFamily.gotham}`,
            fontSize: "14px"
          }
        },
        error: {
          iconTheme: {
            primary: `${colors.base.errorRed}`,
            secondary: "#fff"
          },
          style: {
            background: `${colors.base.lightRed}`,
            padding: "24px 12px",
            fontFamily: `${FontFamily.gotham}`,
            fontSize: "14px"
          }
        },
        loading: {
          style: {
            padding: "1.5rem 0.25rem 1.5rem 1.5rem",
            fontFamily: `${FontFamily.gotham}`,
            fontSize: "14px"
          }
        }
      }}
    />
  )
}
